import axios from "axios";

export const api = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`, withCredentials: true });
const TOKEN_KEY = "availity_token";
export const setToken = (t) => (t ? localStorage.setItem(TOKEN_KEY, t) : localStorage.removeItem(TOKEN_KEY));
api.interceptors.request.use((config) => {
  const t = localStorage.getItem(TOKEN_KEY);
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export const apiUrl = (path) => `${process.env.REACT_APP_BACKEND_URL}/api${path}`;

const fieldError = (x) => {
  const field = x.loc?.[x.loc.length - 1];
  const label = typeof field === "string" && field !== "body" ? `${field[0].toUpperCase()}${field.slice(1).replaceAll("_", " ")}: ` : "";
  return `${label}${(x.msg || JSON.stringify(x)).replace(/^Value error, /, "")}`;
};

export const formatError = (e) => {
  if (e?.isAxiosError && !e.response) return "Can't reach the server. Check your connection and try again.";
  const d = e?.response?.data?.detail;
  if (Array.isArray(d)) return d.map(fieldError).join(" ");
  return d || "Something went wrong. Please try again.";
};

export const money = (minor) => `₹${(Number(minor || 0) / 100).toLocaleString("en-IN", { maximumFractionDigits: 2 })}`;
export const dateTime = (iso) => (iso ? new Date(iso).toLocaleString("en-IN", { day: "numeric", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit", second: "2-digit" }) : "—");
export const date = (iso) => (iso ? new Date(iso).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" }) : "—");
